import { z } from "zod";

/** Largest value a Postgres `integer` (and so a `serial` id) can hold. */
export const POSTGRES_MAX_INTEGER = 2_147_483_647;

/** Postgres `serial` id: positive, at most POSTGRES_MAX_INTEGER. */
export const PostgresSerialId = z.number().int().positive().max(POSTGRES_MAX_INTEGER);

/** {@link PostgresSerialId} for path and query params, which arrive as strings. */
export const PostgresSerialIdParam = z.coerce.number().int().positive().max(POSTGRES_MAX_INTEGER);
